<template>
	<tr class="hover:bg-gray-300">
		<td class="px-6 py-4 text-left whitespace-no-wrap">
			<div class="text-md leading-5  text-gray-900 font-bold">{{ getCompanyName }}</div>
		</td>

		<td class="px-6 py-4 text-left whitespace-no-wrap">
			<div class="text-md leading-5 text-gray-900">{{ getTargetEmail }}</div>
		</td>

		<td class="px-6 py-4 text-left whitespace-no-wrap">
			<div class="text-md leading-5 text-gray-900">{{ getStatus }}</div>
			<div class="text-md leading-5 text-gray-500" v-if="showIsSubscribed">{{ hasSubscription }}</div>
		</td>

		<td class="px-6 py-4 text-left whitespace-no-wrap">
			<div class="flex items-center space-x-2 text-md leading-5 text-gray-900">
				<span>{{ getCode }}</span>

				<!-- Copy code icon
				<font-awesome-icon
					v-if="getCode && isPending"
					:icon="['fas', 'copy']"
					class="cursor-pointer md:w-4 lg:text-lg md:text-xl w-auto text-gray-500 hover:text-connectProBlue lg:mt-0 md:mt-0 mt-4 mx-4"
					@click.stop="copyCode"
				/> -->
			</div>
		</td>

		<td class="px-6 py-4 text-left whitespace-no-wrap">
			<div class="flex items-center space-x-3">
				<div
					v-if="isPending"
					class="cursor-pointer md:w-4 lg:text-lg md:text-xl w-auto text-gray-500 hover:text-connectProBlue lg:mt-0 md:mt-0 mt-4 mx-4"
					@click="openResendModal(invitation)"
					:title="$t('resend_invitation').toString()"
				>
					<font-awesome-icon :icon="['fas', 'envelope']" />
				</div>

				<div
					v-if="invitation?.register_url"
					class="cursor-pointer md:w-4 lg:text-lg md:text-xl w-auto text-gray-500 hover:text-connectProBlue lg:mt-0 md:mt-0 mt-4 mx-4"
					@click="copyUrl"
					:title="$t('copy_invitation_link').toString()"
				>
					<font-awesome-icon :icon="['fas', 'copy']" />
				</div>
			</div>
		</td>
	</tr>
</template>

<script>
import Authentication from '@/mixins/Authentication';

export default {
	name: 'InvitationRow',
	mixins: [Authentication],
	props: {
		invitation: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {};
	},
	computed: {
		getCompanyName() {
			return this.invitation?.company_name;
		},
		getTargetEmail() {
			return this.invitation?.target_email;
		},
		getStatus() {
			switch (this.invitation?.status) {
				case 'pending':
					return 'Ausstehend';
				case 'registered':
					return 'Wartet auf Freigabe';
				case 'accepted':
					return 'Freigegeben';
				default:
					return '';
			}
		},
		getCode() {
			return this.invitation?.code;
		},
		isPending() {
			return this.invitation?.status === 'pending';
		},
		showIsSubscribed() {
			return this.invitation?.status === 'accepted';
		},
		hasSubscription() {
			return this.invitation?.is_subscribed ? 'Aktiver Partner' : 'Inaktiver Partner';
			//return this.$store.getters.getUser.person?
		},
	},
	methods: {
		copyCode() {
			if (!this.getCode) return;

			navigator.clipboard.writeText(this.getCode);
		},
		copyUrl() {
			if (!this.invitation?.register_url) return;

			navigator.clipboard.writeText(this.invitation.register_url);

			this.$swal({
				toast: true,
				position: 'center',
				title: this.$t('invitation_link_copied').toString(),
				showConfirmButton: false,
				timer: 2000,
				timerProgressBar: false,
				//animation: false, => deprecated soon
				showClass: {
					backdrop: 'swal2-noanimation', // disable backdrop animation
					popup: '', // disable popup animation
					icon: '', // disable icon animation
				},
				hideClass: {
					popup: '', // disable popup fade-out animation
				},
			});
		},

		openResendModal(invitation) {
			// example: emit event to parent
			this.$route.name !== 'resendInvite' &&
				this.$router.push({ name: 'resendInvite', params: { id: invitation.id }, query: { email: invitation.target_email } });

			// or open SweetAlert / modal here
		},
	},
};
</script>
